import { PAYMENT_METHODS } from "@/config/constants"

export const paymentMethodsModule = {
  state: {
    paymentMethods: [
      { text: "Terminal", value: PAYMENT_METHODS.TERMINAL },
      { text: "Card Reader", value: PAYMENT_METHODS.CARD_READER },
      { text: "Stripe", value: PAYMENT_METHODS.STRIPE },
      { text: "Manual", value: PAYMENT_METHODS.MANUAL },
      { text: "Other", value: PAYMENT_METHODS.OTHER }
    ]
  },

  getters: {
    paymentMethods: (state) => state.paymentMethods
  },

  actions: {
    addPaymentMethod({ commit }, payload) {
      commit('ADD_PAYMENT_METHOD', payload);
    },

    removePaymentMethod({ commit }, payload) {
      commit('REMOVE_PAYMENT_METHOD', payload);
    }
  },

  mutations: {
    ADD_PAYMENT_METHOD(state, payload) {
      const paymentMethod = state.paymentMethods.find(method => method.value === payload.value);

      if (!paymentMethod) {
        state.paymentMethods = [
          payload,
          ...state.paymentMethods
        ]
      }
    },

    REMOVE_PAYMENT_METHOD(state, payload) {
      state.paymentMethods = state.paymentMethods
        .filter(method => method.value !== payload.value);
    }
  }
};
